var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('future-operations-grid',_vm._b({ref:"operationsGrid"},'future-operations-grid',_vm.$attrs,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }